const targetDate = new Date(Date.UTC(2026, 1, 1, 4, 30, 0));

function updateCountdown() {
  const now = Date.now(); // local device time
  const distance = targetDate.getTime() - now;

  if (distance <= 0) {
    clearInterval(countdownInterval);
    document.getElementById('dDays').innerText = "00";
    document.getElementById('dHours').innerText = "00";
    document.getElementById('dMinutes').innerText = "00";
    document.getElementById('dSeconds').innerText = "00";
    return;
  }

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  document.getElementById('dDays').innerText = String(days).padStart(2, '0');
  document.getElementById('dHours').innerText = String(hours).padStart(2, '0');
  document.getElementById('dMinutes').innerText = String(minutes).padStart(2, '0');
  document.getElementById('dSeconds').innerText = String(seconds).padStart(2, '0');
}

const countdownInterval = setInterval(updateCountdown, 1000);
updateCountdown();
